<template>
    <div class="questionBankContent">
        <div class="qbContentTop">
            <div class="qbContentType">
                题型：
                <Dropdown trigger="click" @on-click="choseType">
                    <a href="javascript:void(0)">
                        {{qbType}}
                        <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list"  >
                        <DropdownItem divided v-for="(item,index) in typeInfo" :key="index" :name="item.name">{{item.name}}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div class="qbContentDifficulty">
                难度：
                <Dropdown trigger="click" @on-click="choseDifficulty">
                    <a href="javascript:void(0)">
                        {{qbDifficulty}}
                        <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list">
                        <DropdownItem divided name="全部">全部</DropdownItem>
                        <DropdownItem divided name="容易">容易</DropdownItem>
                        <DropdownItem divided name="较易">较易</DropdownItem>
                        <DropdownItem divided name="一般">一般</DropdownItem>
                        <DropdownItem divided name="较难">较难</DropdownItem>
                        <DropdownItem divided name="困难">困难</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </div>
        <div class="questionSum">共{{questionTotal}}道相关试题</div>
        <empty v-show="isEmpty"></empty>
        <div class="questionBox" v-show="!isEmpty">
            <List >
                <ListItem class="questionItem" v-for="(item,index) in questionList" :key="index" >
                    <div class="questionType textL">{{index+1}}.{{item.qstTypeName}}</div>
                    <div class="questionBankBox">
                      <div v-if="item.qstSetofQuestion == 0" style="width:100%;">
                          <div class="questionContent textL" v-html="item.questionContent.qstcContentTxt"></div>
                          <div class="option">
                              <div class="opitem" v-if="item.questionContent.qstcOptionA != null && item.questionContent.qstcOptionA != ''">A.<span v-html="item.questionContent.qstcOptionA"> </span></div>
                              <div class="opitem" v-if="item.questionContent.qstcOptionB != null && item.questionContent.qstcOptionB != ''">B.<span v-html="item.questionContent.qstcOptionB">  </span></div>
                              <div class="opitem" v-if="item.questionContent.qstcOptionC != null && item.questionContent.qstcOptionC != ''">C.<span v-html="item.questionContent.qstcOptionC"> </span></div>
                              <div class="opitem" v-if="item.questionContent.qstcOptionD != null && item.questionContent.qstcOptionD != ''">D.<span v-html="item.questionContent.qstcOptionD"> </span></div>
                              <div class="opitem" v-if="item.questionContent.qstcOptionE != null && item.questionContent.qstcOptionE != ''">E.<span v-html="item.questionContent.qstcOptionE"> </span></div>
                              <div class="opitem" v-if="item.questionContent.qstcOptionF != null && item.questionContent.qstcOptionF != ''">F.<span v-html="item.questionContent.qstcOptionF"> </span></div>
                          </div>
                      </div>
                      <div v-else>
                          <div class="questionContent textL" v-html="item.questionContent.qstcContentTxt"></div>
                      </div>
                      <Collapse simple @on-change="viewResolution(index)" v-model="valueQuestionContent">
                          <Panel :name="index+''" class="resolution">
                              <img class="jiexiIcon" src="/static/images/resolution.png" alt="" v-show="filterRate(index)">
                              <img class="jiexiIcon" src="/static/images/resolutioned.png" alt="" v-show="!filterRate(index)">
                              <div slot="content">
                                答案： <div v-html="item.questionContent.qstcAnswerTxt">{{item.questionContent.qstcAnswerTxt}}</div>
                                解析：<div v-html="item.questionContent.qstcAnalyticTxtOne">{{item.questionContent.qstcAnalyticTxtOne}}</div>
                              </div>
                          </Panel>
                      </Collapse>
                    </div>

                </ListItem>
            </List>
            <div class="page" v-show="questionTotal>6">
                <Page :total="questionTotal" :page-size='6' @on-change="changePage"/>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '../../assets/eventBus/enentBus.js'
import api from '../../utils/api.js'
import empty from '../Empty/Empty.vue'
export default {
    name:'questionBankContent',
    components:{empty},
    data(){
        return{
            urlHttp:'/testIp',
            qbType:'全部',
            qbDifficulty:'全部',
            knowledgeId:null,
            questionId:[],                      //存放习题id
            questionTotal:null,                 //习题总数
            questionList:[],                    //习题内容
            isViewResolution0:true,              //是否查看解析  true 未查看  false 查看
            isViewResolution1:true,              //是否查看解析  true 未查看  false 查看
            isViewResolution2:true,              //是否查看解析  true 未查看  false 查看
            isViewResolution3:true,              //是否查看解析  true 未查看  false 查看
            isViewResolution4:true,              //是否查看解析  true 未查看  false 查看
            isViewResolution5:true,              //是否查看解析  true 未查看  false 查看
            difficultId:null,                     //难度默认为 全部 0
            typeId:null,                        //题型默认为全部
            valueQuestionContent:[],            //展开的解析面板
            isEmpty:false,
            level:1,                                //默认级别
            typeInfo:[
                {
                    name:'全部',
                    id:null
                },{
                    name:'选择',
                    id:0
                },{
                    name:'多选',
                    id:3
                },{
                    name:'填空',
                    id:1
                },{
                    name:'填空（主）',
                    id:100
                },{
                    name:'填空（客）',
                    id:101
                },{
                    name:'解答',
                    id:2
                },{
                    name:'写作',
                    id:5
                },{
                    name:'阅读理解',
                    id:4
                },{
                    name:'英语听力',
                    id:14
                },{
                    name:'完成句子',
                    id:7
                },{
                    name:'完形填空',
                    id:6
                },{
                    name:'短文填空',
                    id:11
                },{
                    name:'书面表达',
                    id:12
                },{
                    name:'词汇运用',
                    id:8
                },{
                    name:'补全对话',
                    id:10
                },{
                    name:'句型转换',
                    id:9
                },{
                    name:'任务型阅读',
                    id:31
                },{
                    name:'其他',
                    id:99
                }
            ],
            websiteId:''
        }
    },
    created(){
        this.websiteId = localStorage.getItem("websiteId")
    },
    mounted(){
        const that = this;
        bus.$off('knowledgeId');
        bus.$on('knowledgeId',function(msg){
            that.knowledgeId = msg.knowladgeId;
            that.level = msg.level;
            that.valueQuestionContent = [];
            that.isViewResolution0 = that.isViewResolution1 = that.isViewResolution2 = that.isViewResolution3 = that.isViewResolution4 = that.isViewResolution5 = true;
            that.getQuestionId(1,msg.knowladgeId,msg.level,that.difficultId,that.typeId)
        })
        bus.$off('materialKnowledgeId');
        bus.$on('materialKnowledgeId',function(msg){
            that.knowledgeId = msg.knowladgeId;
            that.level = msg.level;
            that.valueQuestionContent = [];
            that.isViewResolution0 = that.isViewResolution1 = that.isViewResolution2 = that.isViewResolution3 = that.isViewResolution4 = that.isViewResolution5 = true;
            that.getQuestionId(1,msg.knowladgeId,msg.level,that.difficultId,that.typeId)
        })
    },
    methods:{
        getQuestionId(pageNo,id,level,difficultId,typeId){
            const that = this;
            const url =  '/axt-examination/question/pageQuestionsAllByBaseQuery'  // 获取试题 id
            const params = {
                pageSize:6,
                pageNo:pageNo,
                knowledgeIds:id,
                knowledgeLevel:level,
                difficultId:difficultId,
                typeId:typeId,
                websiteId:this.websiteId
            }
            api.getListAPI(url,params).then(res => {
                console.log('题库',res)
                that.questionId = [];
                if(res.data.success){
                    if(res.data.data.total == 0){
                        that.isEmpty = true;
                        that.questionTotal = 0;
                        that.questionList = []
                    }else{
                        that.isEmpty = false;
                        const data = res.data.data;
                        that.questionTotal = data.total;
                        for(let i = 0; i < data.rows.length; i++){
                            that.questionId.push(data.rows[i].qstId)
                        }
                        that.getQuestionData()
                    }
                }else{
                    // that.$Message.error(res.data.message);
                    that.isEmpty = true;
                    that.questionTotal = 0;
                    that.questionList = []
                }
            })
        },
        getQuestionData(){
            const that = this;
            const url =  '/axt-examination/question/getQuestionByIds';
            const params = {
                questionIds:this.questionId
            }
            api.postFormAPI(url,params).then(res => {
                if(res.data.message == "success"){
                    if(res.data.data.length > 0 && res.data.data != null){
                        that.questionList = res.data.data;
                        
                    }

                }
            })
        },
        choseDifficulty(name){
            this.qbDifficulty = name;
            if(name == '全部'){
                this.difficultId = null
            }else if(name == '容易'){
                this.difficultId = 1;
            }else if(name == '较易'){
                this.difficultId = 2;
            }else if(name == '一般'){
                this.difficultId = 3;
            }else if(name == '较难'){
                this.difficultId = 4;
            }else if(name == '困难'){
                this.difficultId = 5;
            }
            this.getQuestionId(1,this.knowledgeId,this.level,this.difficultId,this.typeId)
        },
        choseType(name){
            this.qbType = name;
            for(let i = 0; i < this.typeInfo.length; i++){
                if(name == this.typeInfo[i].name){
                    this.typeId = this.typeInfo[i].id;
                }
            }
            this.getQuestionId(1,this.knowledgeId,this.level,this.difficultId,this.typeId)
        },
        viewResolution(name){
            if(name == 0){
                this.isViewResolution0 = !this.isViewResolution0;
            }else if(name == 1){
                this.isViewResolution1 = !this.isViewResolution1;
            }else if(name == 2){
                this.isViewResolution2 = !this.isViewResolution2;
            }else if(name == 3){
                this.isViewResolution3 = !this.isViewResolution3;
            }else if(name == 4){
                this.isViewResolution4 = !this.isViewResolution4;
            }

        },
        changePage(name){
            this.valueQuestionContent = [];
            this.isViewResolution0 = this.isViewResolution1 = this.isViewResolution2 = this.isViewResolution3 = this.isViewResolution4 = this.isViewResolution5 = true;
            // this.getQuestionId(name,this.knowledgeId,this.difficultId,this.typeId)
            this.getQuestionId(name,this.knowledgeId,this.level,this.difficultId,this.typeId)
        },
        filterRate(index){
            switch(index){
                case 0:
                    return this.isViewResolution0; break
                case 1:
                    return this.isViewResolution1; break
                case 2:
                    return this.isViewResolution2; break
                case 3:
                    return this.isViewResolution3; break
                case 4:
                    return this.isViewResolution4; break
                case 5:
                    return this.isViewResolution5;
            }

        }
    }

}
</script>

<style>
  .questionBankBox {
      width:100%;
      padding-left: 15px;
  }
  .questionBankBox .ivu-collapse-content, .questionBankBox .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header{
    padding-left: 0;
  }
    .questionBankContent{
        width:80%;
        margin-left: 3%;
        border: solid 1px #DADADA;
        border-top: solid 2px #3583FF;
    }
    .qbContentTop{
        border-bottom: solid 1px #DADADA;
        text-align: left;
    }
    .questionSum{
        width:93%;
        margin: 10px auto 0;
        line-height: 40px;
        font-size: 14px;
        color: #9A9A9A;
        text-align: left;
    }
    .qbContentType, .qbContentDifficulty{
        display: inline-block;
        text-align: center;
        border-right: solid 1px #DADADA;
        width:150px;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
    }
    .questionItem{
        display: flex;
        flex-direction: column;
        width:93%;
        border-bottom: solid 1px #DADADA!important;
        margin:0 auto;
    }
    .questionItem .textL{
        width:100%;
        text-align: left!important;
    }
    .questionItem .jiexiIcon{
        width:74px;
        height:16px;
    }
    .questionItem .questionType{
        font-weight: 600;
        padding-bottom: 10px;
    }
    .questionItem .questionTypeName,.questionItem .questionContent,.questionItem .questionAnswer{
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
        padding-bottom: 5px;
    }
    /* 查看解析 的 iview 样式修改  开始 */
    .questionItem .resolution{
        font-size: 14px;
        text-align: left;
    }
    .questionItem .ivu-collapse{
        border: none;
        width: 100%;
    }
    .questionItem .ivu-collapse:hover{
        color: #3583FF;
    }
    .questionItem .ivu-icon{
        display: none;
    }
    .questionItem .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header:hover{
        color: #3583FF;
    }
    /* 结束 */
    .questionItem .Section1 {
        width:100%;
    }
    .questionItem .Section1 p{
        width:100%;
        text-align: left;
    }
    .option .opitem {
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;
    }
    .qbContentType .ivu-dropdown-item, .qbContentDifficulty .ivu-dropdown-item{
        font-size: 14px!important;
        color: #A8A8A8;
    }
    .qbContentType .ivu-dropdown-item:hover, .qbContentDifficulty .ivu-dropdown-item:hover{
        color: #7D7D7D;
    }
    .qbContentType .ivu-dropdown-item-divided, .qbContentDifficulty .ivu-dropdown-item-divided{
        border-top: none;
    }
    /* .qbContentType .ivu-dropdown-menu, .qbContentDifficulty .ivu-dropdown-menu{
        width:147px;
    } */
    .qbContentType .ivu-dropdown .ivu-select-dropdown{
        height: 185px;
        overflow-y: scroll;
    }
    .ivu-dropdown .ivu-select-dropdown::-webkit-scrollbar {
    width: 4px;
    height: 10px;
  }

 .ivu-dropdown .ivu-select-dropdown::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

   .ivu-dropdown .ivu-select-dropdown::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);

  }
</style>



// WEBPACK FOOTER //
// src/components/questionBankContent/questionBankContent.vue